export const Saligorsk = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.000147795898897, 52.51440347930571],
            [27.99363548820969, 52.51766714281479],
            [27.9873860120843, 52.520655042224405],
            [27.981582926789883, 52.52418593489085],
            [27.97711901578515, 52.527716543758345],
            [27.973994277273277, 52.53151842033952],
            [27.969530366268373, 52.537763645839846],
            [27.969530366268373, 52.54265059390099],
            [27.969530366268373, 52.54617971843567],
            [27.967744801147887, 52.54997999655967],
            [27.963280890143153, 52.554051357770845],
            [27.95970976080031, 52.55785095428416],
            [27.950781937892316, 52.56246430766174],
            [27.940961332424138, 52.56300702338331],
            [27.931140726956073, 52.56165022176242],
            [27.92444485999971, 52.5605647505771],
            [27.91596342792269, 52.559479251986204],
            [27.906589213285486, 52.5605647505771],
            [27.903018084841108, 52.56544916021721],
            [27.901232519720452, 52.569790401450746],
            [27.903018084841108, 52.57684400155864],
            [27.903018084841108, 52.583625239530704],
            [27.901232519720452, 52.59013424131393],
            [27.896768608715718, 52.597184568649595],
            [27.89453665276409, 52.603149344396854],
            [27.890519132590327, 52.60884223599464],
            [27.8909655234213, 52.61209498521822],
            [27.896322216986277, 52.61534749228014],
            [27.899893346329122, 52.61588955348225],
            [27.903018084841108, 52.61995479721429],
            [27.902125302280695, 52.62401966344936],
            [27.900786128889536, 52.62591647220569],
            [27.900786128889536, 52.62943889808588],
            [27.89944695549815, 52.63323196311188],
            [27.897661390377664, 52.634315635895575],
            [27.8882871766387, 52.63567018885817],
            [27.884269656464937, 52.63404471994329],
            [27.879359353730763, 52.63187733520493],
            [27.874895441827675, 52.6326901171999],
            [27.870877921653914, 52.63567018885817],
            [27.868199574871312, 52.63946271371856],
            [27.865074836359497, 52.64162972269793],
            [27.859718142794463, 52.645150884276575],
            [27.853915057500046, 52.64731761199948],
            [27.84632640798344, 52.64677593999659],
            [27.839184150196104, 52.645692576407555],
            [27.8342738474621, 52.645692576407555],
            [27.82802437133671, 52.64596341968462],
            [27.822667676873266, 52.647859277293094],
            [27.817757374139205, 52.65246316004277],
            [27.813739853965444, 52.65706655806895],
            [27.811061507182842, 52.664106111540264],
            [27.810615116351926, 52.67141521749079],
            [27.810615116351926, 52.67547530336327],
            [27.805704813617695, 52.685759166386674],
            [27.801240901714664, 52.69171187457545],
            [27.794991425589274, 52.696040607696204],
            [27.789634732024297, 52.69982789696593],
            [27.781153299947277, 52.70415582536009],
            [27.77713577977346, 52.705778687727445],
            [27.76642239174504, 52.707401489744996],
            [27.758833742228433, 52.707401489744996],
            [27.752584266103042, 52.708212868122814],
            [27.747227572537895, 52.711728667117484],
            [27.74410283492449, 52.716055415359335],
            [27.74410283492449, 52.72200399285464],
            [27.740531705581702, 52.72660006560295],
            [27.735175012016498, 52.7320065903873],
            [27.730532543781067, 52.736125911739066],
            [27.725675807587265, 52.74045023947548],
            [27.720533381980488, 52.74425529354835],
            [27.7162480264098, 52.74788708073578],
            [27.715390955475243, 52.75117272211662],
            [27.716533716721244, 52.75376647504709],
            [27.7201930085227, 52.755297662169994],
            [27.73414273187234, 52.75656404222218],
            [27.742512566241544, 52.75698616072464],
            [27.754369831223528, 52.76036296148044],
            [27.756462289591298, 52.763739500982524],
            [27.759949720204247, 52.76922581899055],
            [27.759949720204247, 52.775977261329444],
            [27.759949720204247, 52.78272765609353],
            [27.76310124198625, 52.79161767932186],
            [27.761958480740304, 52.79472727337043],
            [27.7585301970023, 52.800600345091595],
            [27.757387434858003, 52.804400145571776],
            [27.757387434858003, 52.8069907278923],
            [27.761387100117304, 52.80992653514721],
            [27.76595814510108, 52.81165338766721],
            [27.773671784409657, 52.812689466254085],
            [27.78081404309529, 52.81407086595732],
            [27.784813707456294, 52.815970219412634],
            [27.78509939776785, 52.8199413254934],
            [27.780528352783904, 52.82270362061615],
            [27.77401104215994, 52.827591157463246],
            [27.770439912817096, 52.83325483322875],
            [27.770439912817096, 52.83676054856227],
            [27.77356465043067, 52.841074886616354],
            [27.77356465043067, 52.84511918895436],
            [27.76776156603455, 52.84997185454762],
            [27.761958480740304, 52.85509352461082],
            [27.757048178006073, 52.85913652119933],
            [27.753477048663285, 52.867490854919424],
            [27.750798701880854, 52.87395762080348],
            [27.744995616586436, 52.880962196157725],
            [27.736960576238857, 52.88688826111593],
            [27.732050273504683, 52.891197617912326],
            [27.729480350513256, 52.89157475915465],
            [27.715533801080085, 52.89362144265266],
            [27.704820413051664, 52.89200557455257],
            [27.693678490005084, 52.88946315343077],
            [27.689678825644307, 52.88842890561659],
            [27.683965018516062, 52.88791177245611],
            [27.679393973532115, 52.888773657629656],
            [27.67368016640404, 52.890497376569726],
            [27.66882343110848, 52.88998026808463],
            [27.660252720865458, 52.88773939336522],
            [27.653110462179825, 52.88342969278017],
            [27.644539751936804, 52.87808506920254],
            [27.632826448267224, 52.87205002509472],
            [27.623112976778202, 52.866531535539934],
            [27.614256576223454, 52.861184829302545],
            [27.609114150616676, 52.85876997205543],
            [27.601971891931044, 52.85687248940246],
            [27.594543942933797, 52.85859747710998],
            [27.590258588261463, 52.861357313963765],
            [27.587115994835074, 52.86497933401796],
            [27.587115994835074, 52.86704892370676],
            [27.588830136703905, 52.869290868339704],
            [27.59425825262241, 52.87222246656489],
            [27.599972059750485, 52.87411927749042],
            [27.60282896286543, 52.87756781265864],
            [27.60282896286543, 52.88032644293486],
            [27.597115156635482, 52.882740101017134],
            [27.591401349507464, 52.88360208900747],
            [27.583402019887217, 52.8839468794053],
            [27.577598935491267, 52.88500278314592],
            [27.568224720854005, 52.887965640747666],
            [27.561082462168372, 52.89038964621176],
            [27.555725768603395, 52.893082826465275],
            [27.551708248429463, 52.89793013011246],
            [27.552154639260436, 52.902238389220145],
            [27.555725768603395, 52.90573853387622],
            [27.561082462168372, 52.909507604584235],
            [27.561975244728615, 52.91327634737263],
            [27.560636071337456, 52.916775600829965],
            [27.55527937777225, 52.920005429670255],
            [27.552154639260436, 52.92404237696206],
            [27.550369075038248, 52.92619526179817],
            [27.54278042552164, 52.928348039576065],
            [27.537423731956494, 52.92807894841161],
            [27.531174255831104, 52.925118833033366],
            [27.52581756136783, 52.92404237696206],
            [27.520460867802626, 52.92350413943126],
            [27.515996955899595, 52.92296589466747],
            [27.510640262334448, 52.919197995044385],
            [27.509747479774205, 52.9148914223955],
            [27.509301088943232, 52.909238396316255],
            [27.50885469811226, 52.90573853387622],
            [27.50439078620923, 52.902776891084784],
            [27.499034092644024, 52.90143062279094],
            [27.490999051397978, 52.90116136432937],
            [27.480285664268024, 52.900622841844836],
            [27.476268144094092, 52.89954577733897],
            [27.46912588540846, 52.89793013011246],
            [27.466447538626028, 52.899007234775695],
            [27.46510836523464, 52.90250764098914],
            [27.461537235891853, 52.907353889970636],
            [27.456180542326877, 52.909507604584235],
            [27.447699110249857, 52.90977681172063],
            [27.44011046073325, 52.90869997421987],
            [27.432075419487376, 52.90681544499279],
            [27.424040379139626, 52.90250764098914],
            [27.417790903014406, 52.89873796125528],
            [27.409309470937387, 52.89254420412658],
            [27.39547134529539, 52.885541499194915],
            [27.390561042561387, 52.88230910032473],
            [27.38297239304478, 52.877998859935985],
            [27.37672291691939, 52.87584357962123],
            [27.36645592062024, 52.87584357962123],
            [27.360206444494793, 52.87665182242688],
            [27.353956968369403, 52.877729455889664],
            [27.349493056466372, 52.878807063117506],
            [27.34056523355855, 52.88015403368371],
            [27.335208539993403, 52.880962196157725],
            [27.32851267303704, 52.880962196157725],
            [27.322709587742622, 52.880962196157725],
            [27.317352894177645, 52.88177034357017],
            [27.313335374003827, 52.88419469597966],
            [27.31154980888317, 52.88904299306273],
            [27.308871462100626, 52.893082826465275],
            [27.30306837680621, 52.89846868606145],
            [27.295926119018873, 52.89954577733897],
            [27.288337469502267, 52.899276507164984],
            [27.285212730990565, 52.89846868606145],
            [27.28030242825639, 52.89819940865277],
            [27.274945734691244, 52.899007234775695],
            [27.271820996179542, 52.90169988012116],
            [27.272267387908812, 52.90466159653141],
            [27.278963254865175, 52.909238396316255],
            [27.285212730990565, 52.91246878727583],
            [27.291462207115785, 52.91650643719157],
            [27.29503333645863, 52.919467141411985],
            [27.295926119018873, 52.92404237696206],
            [27.289230251164213, 52.928886217428385],
            [27.281195210816634, 52.932653273966935],
            [27.27137460534857, 52.93615096113547],
            [27.26333956500082, 52.93857227194417],
            [27.253072567803372, 52.94099344673282],
            [27.245930310016035, 52.94341448604621],
            [27.239234442161376, 52.94583538988718],
            [27.231199401813797, 52.948794088570025],
            [27.227181881640035, 52.948525124521495],
            [27.220039622954403, 52.94744925052038],
            [27.2146829293892, 52.944490460394434],
            [27.208433453263808, 52.94233848547918],
            [27.20263036796956, 52.94045541941841],
            [27.19638089184417, 52.93642000266101],
            [27.19639929964427, 52.93630905514942],
            [27.196827282675144, 52.93372951538612],
            [27.200844803747202, 52.9286171290679],
            [27.203523150529804, 52.92458060834332],
            [27.20263036796956, 52.918659696748875],
            [27.196827282675144, 52.915698937321906],
            [27.188792242327565, 52.91300716252721],
            [27.18120359281096, 52.91166121212183],
            [27.170490204782368, 52.91004601664224],
            [27.16647268460855, 52.90520006827916],
            [27.16647268460855, 52.90116136432937],
            [27.17316855246321, 52.89416005214673],
            [27.179864419419573, 52.888773657629656],
            [27.18298915703315, 52.884464059861045],
            [27.178971636859387, 52.878807063117506],
            [27.16691907633782, 52.877190642234325],
            [27.16022320848333, 52.87557416164401],
            [27.149509821353035, 52.87180213911114],
            [27.14192117183643, 52.86856871600105],
            [27.13567169571104, 52.864257109908294],
            [27.137010869102426, 52.85913652119933],
            [27.144153126889762, 52.85482397829435],
            [27.150402603015152, 52.85158928921328],
            [27.1562056883094, 52.84673680441904],
            [27.157991252531758, 52.841344518310564],
            [27.155759297478426, 52.83649088840639],
            [27.14995621218401, 52.83109732934656],
            [27.14459951861903, 52.827591157463246],
            [27.138350042493585, 52.82300573606898],
            [27.132100566368194, 52.816531375845045],
            [27.125404698513705, 52.81275422041358],
            [27.1182624407262, 52.812214599831236],
            [27.114244920552437, 52.813293834297326],
            [27.110227399480323, 52.816531375845045],
            [27.10620987930656, 52.8194989106093],
            [27.100853185741414, 52.821926742741084],
            [27.093264536224808, 52.82354522214314],
            [27.08746145093056, 52.82354522214314],
            [27.079872801413785, 52.82381496321136],
            [27.07496249867978, 52.824893909110926],
            [27.06782023999415, 52.82786087287201],
            [27.061124373037785, 52.827591157463246],
            [27.05532128774331, 52.82651227799835],
            [27.048179029955975, 52.823275479943334],
            [27.04237594466173, 52.81976867625218],
            [27.04211682112242, 52.819433100656056],
            [27.03925120704821, 52.8157220130654],
            [27.03657285936731, 52.80654818118052],
            [27.03434090431398, 52.79980148134382],
            [27.031216165802164, 52.79386351954298],
            [27.02809142818859, 52.78522503736508],
            [27.02809142818859, 52.779285085629624],
            [27.027395153208545, 52.77633678438343],
            [27.037938682124604, 52.77421070805781],
            [27.036149926078394, 52.76717635130774],
            [27.038833060597426, 52.76068208960686],
            [27.04241057179064, 52.75851712016902],
            [27.05135435112254, 52.753104225779396],
            [27.054037484742196, 52.747149265926],
            [27.05314310716875, 52.73956904947221],
            [27.04777683902995, 52.73307067067498],
            [27.0468824605573, 52.72548800446788],
            [27.0468824605573, 52.718987526653166],
            [27.05672061836202, 52.71248608026855],
            [27.06655877526731, 52.710318715936125],
            [27.077291309746215, 52.7086931220901],
            [27.081763200311627, 52.70110621737814],
            [27.079974444265247, 52.69189177358652],
            [27.072819420979556, 52.682133183299925],
            [27.065664397693865, 52.67779533218891],
            [27.0468824605573, 52.67399935858356],
            [27.037938682124604, 52.67183008319188],
            [27.03078365973829, 52.668575968206426],
            [27.030700110750843, 52.66823815197773],
            [27.028100525219088, 52.6577271666755],
            [27.03078365973829, 52.65230175552176],
            [27.034361170032014, 52.650674001503944],
            [27.04241057179064, 52.650674001503944],
            [27.05135435112254, 52.651216593071354],
            [27.057614996834786, 52.651216593071354],
            [27.063875641647655, 52.64904618633261],
            [27.071030664933346, 52.64144891423604],
            [27.069241908887136, 52.63493591695902],
            [27.071030664933346, 52.6300505316068],
            [27.07550255459938, 52.62407876612235],
            [27.081763200311627, 52.61756318239503],
            [27.087129467550938, 52.612675858104524],
            [27.087129467550938, 52.6083311118914],
            [27.082657577885072, 52.60615857735655],
            [27.0701362873599, 52.60398593400373],
            [27.06029813045444, 52.604529104734524],
            [27.055826240788406, 52.602899572757224],
            [27.05314310716875, 52.59692410206583],
            [27.05672061836202, 52.590947815689276],
            [27.062086885601445, 52.58551412177934],
            [27.06298126317489, 52.581166680298224],
            [27.06029813045444, 52.57518824544121],
            [27.0647700192211, 52.57083978053163],
            [27.073713799452378, 52.56594724197174],
            [27.079974444265247, 52.562141556587676],
            [27.08355195545846, 52.5572480476593],
            [27.08355195545846, 52.5512663509615],
            [27.087129467550938, 52.54528383857843],
            [27.080868821838692, 52.542020306791756],
            [27.0701362873599, 52.538756532188245],
            [27.059403752880996, 52.537668553061394],
            [27.059403752880996, 52.534404454701985],
            [27.06298126317489, 52.53005194644027],
            [27.0701362873599, 52.52787553043157],
            [27.074608177025766, 52.52461070362125],
            [27.079080065792425, 52.519713009248164],
            [27.081763200311627, 52.51100464814607],
            [27.08355195545846, 52.501205679198904],
            [27.08355195545846, 52.49630537589246],
            [27.088918223597318, 52.49194909137765],
            [27.101439514122433, 52.48868159537943],
            [27.108594537408123, 52.487592376087434],
            [27.117538316740024, 52.487592376087434],
            [27.126482096071925, 52.487592376087434],
            [27.141686520216865, 52.487592376087434],
            [27.1461584098829, 52.487592376087434],
            [27.148841543502556, 52.48105649376231],
            [27.149735921075944, 52.47451964016932],
            [27.149735921075944, 52.469616362805084],
            [27.15063029864939, 52.463077808594164],
            [27.15063029864939, 52.45926320463326],
            [27.15063029864939, 52.45326815749951],
            [27.157785322834457, 52.449997788167536],
            [27.17030661335957, 52.449997788167536],
            [27.180144770265088, 52.449997788167536],
            [27.181039147838476, 52.44509177866274],
            [27.179250391792266, 52.43473285403803],
            [27.183722282357508, 52.426553034395056],
            [27.184616659930953, 52.41837169579719],
            [27.198032328928832, 52.41564424628507],
            [27.223969287552734, 52.41946262919714],
            [27.23291306778401, 52.41946262919714],
            [27.241856846216535, 52.41728073721629],
            [27.247223114355336, 52.4118255333218],
            [27.257061271260852, 52.40691527272173],
            [27.259744404880507, 52.40255013797861],
            [27.26511067211993, 52.3992760040843],
            [27.279420718691313, 52.39491011391067],
            [27.29535417735343, 52.391327857894396],
            [27.296413898882463, 52.39108960500141],
            [27.312512701500054, 52.39491011391067],
            [27.3187733472123, 52.40418711454379],
            [27.32682274807155, 52.41073441106437],
            [27.333083393783625, 52.41782622010413],
            [27.34202717221632, 52.42218984308687],
            [27.355442841214256, 52.426007659426034],
            [27.374224777451673, 52.432551716588534],
            [27.38585169040317, 52.44018522326951],
            [27.391217957642823, 52.44836251311955],
            [27.392112336115474, 52.45708328216779],
            [27.38406293435696, 52.46798181530863],
            [27.377802289544093, 52.477788188374234],
            [27.374224777451673, 52.485413856564264],
            [27.373330399878228, 52.49412728804407],
            [27.378696667117538, 52.497394379347156],
            [27.393006713689033, 52.4979388711821],
            [27.403739249067144, 52.502838992825446],
            [27.407316760260414, 52.51046031908851],
            [27.413577405073283, 52.51590331378702],
            [27.42252118530456, 52.52188982995176],
            [27.43057058616381, 52.52678728150789],
            [27.441303120642544, 52.53005194644027],
            [27.453824411167716, 52.52733140911738],
            [27.455613167213926, 52.52733140911738],
            [27.473500725877898, 52.52243401871516],
            [27.479761371590143, 52.526243147603225],
            [27.49138828454187, 52.533316367656425],
            [27.49943768540095, 52.538212545772524],
            [27.50838146473285, 52.538212545772524],
            [27.525374644024623, 52.53386041432674],
            [27.533424045783136, 52.53222825453042],
            [27.541473446642385, 52.53222825453042],
            [27.560255382879802, 52.53658054695484],
            [27.566516029491254, 52.54093240860385],
            [27.57009353978509, 52.54637162884768],
            [27.578142941543547, 52.54800326343991],
            [27.587086720875448, 52.54691551364016],
            [27.59513612263413, 52.542020306791756],
            [27.59781925535441, 52.54147636084548],
            [27.604974278640043, 52.53712455315565],
            [27.61660119159177, 52.538756532188245],
            [27.619284325211595, 52.539844484335674],
            [27.630016860589706, 52.54256424554353],
            [27.647010040780856, 52.54093240860385],
            [27.659531331306027, 52.534948487882446],
            [27.659531331306027, 52.530596033580196],
            [27.664897599444828, 52.52787553043157],
            [27.6532706864931, 52.52134563489318],
            [27.648798796827066, 52.51427048669376],
            [27.65505944163999, 52.50937163849039],
            [27.658636953732582, 52.49957230531777],
            [27.65505944163999, 52.48922619513286],
            [27.663108843398447, 52.48650312981562],
            [27.678313267543388, 52.48650312981562],
            [27.689940180495114, 52.48868159537943],
            [27.708722116732304, 52.48377989632513],
            [27.71677151759161, 52.47942237164523],
            [27.72034902968403, 52.46743695295305],
            [27.725715297822887, 52.46144301918008],
            [27.733764698681966, 52.45762827312643],
            [27.74449723316087, 52.451087939157105],
            [27.745391610734316, 52.44563691800943],
            [27.74449723316087, 52.43909480338266],
            [27.747180366780526, 52.43582338094433],
            [27.765067925444498, 52.43146110784403],
            [27.79100488496755, 52.43364229925288],
            [27.824991245349736, 52.432551716588534],
            [27.850928204872787, 52.432551716588534],
            [27.866132629917104, 52.43146110784403],
            [27.887597698874742, 52.42927980941579],
            [27.91174590325096, 52.425462277262454],
            [27.934999728255036, 52.42382609030193],
            [27.959147932631083, 52.42818911883296],
            [27.973457979202408, 52.43146110784403],
            [27.983296136107924, 52.43582338094433],
            [27.990451159393615, 52.44563691800943],
            [27.98597926972758, 52.45381319522289],
            [27.986873648200344, 52.460898075885666],
            [27.99581742663304, 52.471795663838975],
            [28.005655583538385, 52.47724344742727],
            [28.007444339584765, 52.48377989632513],
            [28.007444339584765, 52.49303820365037],
            [28.001183694771726, 52.50011677017284],
            [27.99671180510586, 52.50338341721101],
            [27.99671180510586, 52.50882728874842],
            [28.000147795898897, 52.51440347930571],
          ],
        ],
      },
      properties: {
        shapeName: "Salihorsk",
        shapeISO: "",
        shapeID: "67162791B12460087089540",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
